import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PdfViewerModule } from 'ng2-pdf-viewer';

import { MenuItems } from './menu-items/menu-items';
import { AppHeaderToolbarComponent } from './app-header-toolbar/app-header-toolbar.component';

import { AppFiltersModalComponent } from './app-filters-modal/app-filters-modal.component';
import { CoreModule } from '../_core/core.module';
import { AppFiltersComponent } from './app-filters/app-filters.component';
import { AppListScrollerComponent } from './app-list-scroller/app-list-scroller.component';
import { AppBrowserFrameComponent } from './app-browser-frame/app-browser-frame.component';
import { AppDocumentDisplayComponent } from './app-document-display/app-document-display.component';
import { AppDocumentSaveComponent } from './app-document-save/app-document-save.component';
import { ProductItemHeaderSingleComponent } from './product-item-header-single/product-item-header-single.component';
import { ProductItemHeaderMultipleComponent } from './product-item-header-multiple/product-item-header-multiple.component';
import { NeftCreditDisplayComponent } from './neft-credit-display/neft-credit-display.component';
import { LoadingSkeletonListComponent } from './loading-skeleton-list/loading-skeleton-list.component';
import { AppFileUploadComponent } from './app-file-upload/app-file-upload.component';
import { AppMultipartFileUploadComponent } from './app-multipart-file-upload/app-multipart-fille-upload.component';
import { StepperInputComponent } from './stepper-input/stepper-input.component';
import { ListDisplayComponent } from './list-display/list-display.component';
import { AppCustomSelectComponent } from './app-custom-select/app-custom-select.component';
import { AppCurrencyDisplayComponent } from './app-currency-display/app-currency-display.component';
import { SlimscrollDirective } from './slimscroll.directive';
import { PortletComponent } from './portlet/portlet.component';
import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { LibModule } from '../_libs/lib.module';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { AppQrCodeGeneratorComponent } from './app-qr-code-generator/app-qr-code-generator.component';
import { WizardTabsComponent } from './wizard-tabs/wizard-tabs.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TopInvoiceKnockOffSelectionComponent } from './top-invoice-knock-off-selection/top-invoice-knock-off-selection.component';

const components = [
  AppHeaderToolbarComponent,
  AppFiltersComponent,
  AppFiltersModalComponent,
  AppListScrollerComponent,
  AppBrowserFrameComponent,
  AppDocumentDisplayComponent,
  AppDocumentSaveComponent,
  ProductItemHeaderSingleComponent,
  ProductItemHeaderMultipleComponent,
  NeftCreditDisplayComponent,
  LoadingSkeletonListComponent,
  AppFileUploadComponent,
  AppMultipartFileUploadComponent,
  StepperInputComponent,
  ListDisplayComponent,
  AppCustomSelectComponent,
  AppCurrencyDisplayComponent,
  ListDisplayComponent,
  SlimscrollDirective,
  PortletComponent,
  PagetitleComponent,
  AppQrCodeGeneratorComponent,
  WizardTabsComponent,
  TopInvoiceKnockOffSelectionComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LibModule,
    CoreModule,
    PdfViewerModule,
    NgxQRCodeModule
  ],
  declarations: components,
  exports: components,
  providers: [
    MenuItems,
    NgbActiveModal
  ],
  entryComponents: [AppFiltersModalComponent, AppQrCodeGeneratorComponent]
})
export class SharedModule { }